import React, { Component } from 'react';
import { connect } from 'react-redux';
import AppLayout from '../AppLayout';
import { withRouter } from 'react-router-dom';
import { listMarketplace } from '../../Api';

class MarketplaceIndex extends Component {
  state = {
    nombre: "",
  };

  componentDidMount() {
    listMarketplace(this.props.usuario.token).then(roles => {
      this.props.dispatch({
        type: 'setMarketplace',
        payload: roles
      })
    })
  }

  handleSubmit = async event => {
    event.preventDefault();
  };

  onInputChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
    document.getElementById(event.target.id).classList.remove("is-danger");
  };

  render() {
    return (
      <AppLayout>
        <div className="content">
          <div className='form-horizontal'>
            <h2>Plazas</h2>
            <button className='btn btn-primary' onClick={(event) => {
              event.preventDefault();
              this.props.history.push('/marketplaces/new')
            }}>Nuevo</button>
          </div>
          {this.props.marketplaces.length > 0 ? (
            <table className="table table-responsive">
              <thead>
                <tr>
                  <td>Acciones</td>
                  <td>Nombre</td>
                </tr>
              </thead>
              <tbody>
                {this.props.marketplaces.map((item) => {
                  return (<tr key={`${item._id}`}>
                    <td>
                      <button className='btn btn-sm btn-default' onClick={() => {
                        this.props.history.push('/marketplaces/' + item._id + '/edit')
                      }}>Editar</button>
                    </td>
                    <td>{item.name}</td>
                  </tr>)
                })}
              </tbody>

            </table>
          ) : (
            <div className="alert alert-info">
              <span>Sin datos</span>
            </div>
          )}
        </div>
      </AppLayout>
    );
  }
}

const mapStoreToProps = (state, props) => {
  return {
    ...props,
    usuario: state.usuario,
    marketplaces: state.marketplaces
  }
}
export default withRouter(connect(mapStoreToProps)(MarketplaceIndex));